import React from 'react'
import {Link} from 'react-router-dom'
import couple1 from '../../images/couple/1.jpg'
import couple2 from '../../images/couple/2.jpg'
import couple3 from '../../images/couple/3.jpg'
import './style.css'

const Couple2 = () => {
    return(
        <div id="couple" className="couple-area section-padding pb-70">
            <div className="container">
                <div className="col-l2">
                    <div className="section-title text-center">
                        <h2>Happy Couple</h2>
                    </div>
                </div>
                <div className="couple-wrap">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 couple-single">
                            <div className="couple-wrap2">
                                <div className="couple-img3">
                                    <img src={couple1} alt=""/>
                                </div>
                                <div className="couple-text">
                                    <div className="couple-content">
                                        <h4>SUPUNI</h4>
                                        <p>Hi there! I’m a shy but fun-loving girl who’s happiest when surrounded by flowers. They’ve always been my little joy, and then came him—the guy who made my life bloom by bringing me flowers every single day. It’s no wonder I fell in love with him! Now, we’re starting the most beautiful chapter of our story, and I can’t wait to share it with you all.</p>
                                    </div>
                                    <div className="social-icon">
                                        <ul className="d-flex">
                                            <li><Link to="/home2"><i className="fa fa-instagram"></i></Link></li>
                                            <li><Link to="/home2"><i className="fa fa-facebook"></i></Link></li>
                                            <li><Link to="/home2"><i className="fa fa-linkedin"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 couple-single">
                            <div className="couple-img2">
                                <img src={couple3} alt=""/>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 couple-single md-0">
                            <div className="couple-wrap2">
                                <div className="couple-img3">
                                     <img src={couple2} alt=""/>
                                </div>
                                <div className="couple-text">
                                    <div className="couple-content">
                                        <h4>THUSHAL</h4>
                                        <p>Hello! I’m not so shy and definitely more talkative than my girlfriend—a workaholic who met a girl at the office and had his life changed forever. Now, I just want to spend the rest of my days with her, sharing every adventure together.</p>
                                    </div>
                                    <div className="social-icon">
                                        <ul className="d-flex">
                                            <li><Link to="/home2"><i className="fa fa-instagram"></i></Link></li>
                                            <li><Link to="/home2"><i className="fa fa-facebook"></i></Link></li>
                                            <li><Link to="/home2"><i className="fa fa-linkedin"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                
    )
}

export default Couple2;